import { execute } from "../../helpers/apiInstance";

export const getCityState = (zipcode) => {
    return execute('POST', `/ui/apis/get-city-state?type=GetCityStateForZipCode`,{zip5:zipcode},'json');
}

export const getCustomerDetails = (dataObj) => {  
    return execute('POST', `/ui/apis/get-customer-data/`,dataObj ,'json');
}

export const getValidateCoordinates = (dataObj) => {  
    return execute('POST', `/ui/apis/get-validate-latlong/`,dataObj ,'json');
}